import React from 'react';
import { Box, IconChevronLeft24, Link } from '@stitch-fix/mode-react';
import './styles.module.scss';

const BackToPreviousPageHeader = () => {
  const params = new URLSearchParams(window.location.search);

  const styledFixShipment = params.get('styledFixShipment');
  const isStyledFixPdp = !!styledFixShipment;

  const returnLink = isStyledFixPdp
    ? `/fixes/${styledFixShipment}`
    : '/fix-preview';

  return (
    <Box as="header" styleName="header" data-testid="back-to-previous-page">
      <Box
        as="nav"
        display="flex"
        pl={{ sm: 1, md: 2 }}
        height={{ sm: 3, md: 3.5 }}
        styleName="nav"
      >
        <Link
          size="cta"
          href={returnLink}
          startIcon={<IconChevronLeft24 />}
          target="_self"
        >
          Back
        </Link>
      </Box>
    </Box>
  );
};

export default BackToPreviousPageHeader;
